import { createFileRoute, redirect } from "@tanstack/react-router";
import { AutomationPage } from "./-automationPage/AutomationPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { queryClient, trpc } from "~/utils/trpc";
import { hasPermission } from "~/store/usePermissionStore";

export const Route = createFileRoute("/_dashboard/$datasetSlug/automations/$automationId/")({
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(() => null);

    if (!hasPermission({ role: session?.user?.role, permissions: session?.user?.permissions }, "automations", "view")) {
      throw redirect({ to: "/$datasetSlug/dashboard", params: { datasetSlug: params.datasetSlug } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { automationId, datasetSlug } = Route.useParams();
  useBreadCrumbs([
    { title: "Automations", link: `/${datasetSlug}/automations` },
    { title: "Details", link: `/${datasetSlug}/automations/${automationId}` },
  ]);
  return <AutomationPage id={automationId} />;
}
